import styled from "styled-components";

export const HeaderFourDesktopCont = styled.nav`
  button {
    width: 268px;
    border: 1px solid #000;
    border-radius: ${({ theme }) =>
      theme.isRTL ? `8px 0 0 8px` : `0 8px 8px 0`};
  }
`;
